import { render, staticRenderFns } from "./Distancias.vue?vue&type=template&id=8143c604"
import script from "./Distancias.vue?vue&type=script&lang=js"
export * from "./Distancias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports